import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import { FeeTableStructure, TradeFee } from 'src/app/models/exchange-fees';
import { Coin } from 'src/app/models/coin';
import { AuthService } from 'src/app/api/auth.service';

@Component({
  selector: 'fees-trading',
  templateUrl: './fees-trading.component.html',
  styleUrls: ['./fees-trading.component.scss', '../../fees-page/fees-page.component.scss']
})
export class FeesTradingComponent implements OnInit {
  @Input() tradeFees: TradeFee[];
  @Input() last30DaysVolume: Coin;

  @ContentChild('start') startButton: TemplateRef<void>;

  fiatDigitalFee: FeeTableStructure;
  digitalFee: FeeTableStructure;

  constructor(private auth: AuthService) { }

  ngOnInit() {
    this.createFeeTableStructure();
  }

  createFeeTableStructure() {
    this.fiatDigitalFee = {
      fee: this.getFeeByType('fiatDigitalPairs'),
      discountedFee: this.getFeeByType('fiatDigitalDiscountedPairs'),
      last30DaysVolume: this.last30DaysVolume,
    };

    this.digitalFee = {
      fee: this.getFeeByType('digitalPairs'),
      discountedFee: this.getFeeByType('digitalDiscountedPairs'),
      last30DaysVolume: this.last30DaysVolume,
    };
  }

  getFeeByType(searchedType: string) {
    return this.tradeFees?.find(({ type }) => type === searchedType);
  }

  isLoggedIn() {
    return this.auth.getToken();
  }
}
